import { useTranslation } from "react-i18next";

export default function Cookies() {
  const { t } = useTranslation();

  const openPrefs = () => {
    window.dispatchEvent(new Event("open-cookie-preferences"));
  };

  return (
    <section className="bg-white">
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-20" data-testid="cookies-page">
        <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#525252]">
          {t("cookies.page_eyebrow")}
        </div>
        <h1 className="font-display mt-3 text-4xl sm:text-5xl font-bold uppercase tracking-tighter leading-[0.95] text-[#001F3F]">
          {t("cookies.page_title")}
        </h1>
        <p className="mt-6 text-base text-[#404040] leading-relaxed">
          {t("cookies.page_intro")}
        </p>

        <button
          onClick={openPrefs}
          className="mt-8 inline-flex items-center gap-2 bg-[#001F3F] text-white hover:bg-[#FFD700] hover:text-[#001F3F] transition-all uppercase tracking-[0.25em] text-xs font-bold px-6 py-3"
          data-testid="cookies-manage-btn"
        >
          {t("cookies.manage_button")}
        </button>

        <div className="mt-12 space-y-10 text-sm text-[#262626] leading-relaxed">
          <article>
            <h2 className="font-display text-2xl font-bold uppercase tracking-tighter text-[#001F3F] mb-3">
              {t("cookies.section1_title")}
            </h2>
            <p>{t("cookies.section1_body")}</p>
          </article>

          <article>
            <h2 className="font-display text-2xl font-bold uppercase tracking-tighter text-[#001F3F] mb-3">
              {t("cookies.section2_title")}
            </h2>
            <div className="overflow-x-auto">
              <table className="w-full text-xs border border-[#E5E5E5]">
                <thead className="bg-[#F5F5F5] uppercase tracking-widest text-[#525252]">
                  <tr>
                    <th className="text-left p-3 border-b border-[#E5E5E5]">{t("cookies.tbl_category")}</th>
                    <th className="text-left p-3 border-b border-[#E5E5E5]">{t("cookies.tbl_purpose")}</th>
                    <th className="text-left p-3 border-b border-[#E5E5E5]">{t("cookies.tbl_provider")}</th>
                    <th className="text-left p-3 border-b border-[#E5E5E5]">{t("cookies.tbl_duration")}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="p-3 border-b border-[#E5E5E5] font-semibold">{t("cookies.row_essential")}</td>
                    <td className="p-3 border-b border-[#E5E5E5]">{t("cookies.row_essential_purpose")}</td>
                    <td className="p-3 border-b border-[#E5E5E5]">Nord Stella Tech, Stripe</td>
                    <td className="p-3 border-b border-[#E5E5E5]">Session – 12 mois</td>
                  </tr>
                  <tr>
                    <td className="p-3 border-b border-[#E5E5E5] font-semibold">{t("cookies.row_analytics")}</td>
                    <td className="p-3 border-b border-[#E5E5E5]">{t("cookies.row_analytics_purpose")}</td>
                    <td className="p-3 border-b border-[#E5E5E5]">Google Analytics 4</td>
                    <td className="p-3 border-b border-[#E5E5E5]">13 mois</td>
                  </tr>
                  <tr>
                    <td className="p-3 font-semibold">{t("cookies.row_marketing")}</td>
                    <td className="p-3">{t("cookies.row_marketing_purpose")}</td>
                    <td className="p-3">Google Ads</td>
                    <td className="p-3">90 jours</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </article>

          <article>
            <h2 className="font-display text-2xl font-bold uppercase tracking-tighter text-[#001F3F] mb-3">
              {t("cookies.section3_title")}
            </h2>
            <p>{t("cookies.section3_body")}</p>
          </article>

          <article>
            <h2 className="font-display text-2xl font-bold uppercase tracking-tighter text-[#001F3F] mb-3">
              {t("cookies.section4_title")}
            </h2>
            <p>{t("cookies.section4_body")}</p>
          </article>

          <p className="text-xs text-[#737373] pt-6 border-t border-[#E5E5E5]">
            {t("cookies.last_update")} : 15/02/2026
          </p>
        </div>
      </div>
    </section>
  );
}
